module.exports = "/_next/static/images/CollectDataTabs-1-lg@2x-0ba4404e6fffc100c6e54e20769cda87.webp";